package dev.akshaychordiya.content

/**
 * Everything about "who this site belongs to" lives here, so changing a handle or a job title is a one-line edit
 * rather than a grep across the codebase.
 */
object Site {
    const val NAME = "Akshay Chordiya"
    const val CREDENTIAL = "Google Developer Expert for Android 🤖"
    const val LOCATION = "Currently based in UK & worked in 4 countries 🇬🇧🇺🇸🇩🇪🇮🇳 across 3 continents 🌎"
    const val URL = "https://akshaychordiya.dev"

    const val EMAIL = "akshaychordiya2@gmail.com"

    val socials = listOf(
        Social("GitHub", "https://github.com/AkshayChordiya"),
        Social("LinkedIn", "https://www.linkedin.com/in/akshaychordiya/"),
        Social("X", "https://twitter.com/Akshay_Chordiya"),
        Social("Medium", "https://medium.com/@aky"),
        Social("Sessionize", "https://sessionize.com/akshay-chordiya/"),
        Social("Play Store", "https://play.google.com/store/apps/developer?id=Akshay+Chordiya"),
    )
}

class Social(val label: String, val url: String)

class NavItem(val path: String, val label: String)

val navItems = listOf(
    NavItem("/", "Home"),
    NavItem("/articles", "Articles"),
    NavItem("/talks", "Talks"),
    NavItem("/books", "Books"),
    NavItem("/apps", "Apps"),
    // Straight out to Topmate rather than to a page about Topmate. Kobweb's Link renders an absolute URL as a plain
    // anchor, and isActive never matches it, which is right - you're never "on" this one.
    NavItem(Mentoring.TOPMATE_PROFILE, "1:1"),
    NavItem("/about", "About"),
)
